// CreateClass.tsx
import React from 'react';
import { Form, Input, Button } from 'antd';
import { postRequest, ResponseDataType } from 'api';
import { toast } from 'react-toastify';

interface Props {
  schoolId: number;
  onSuccess: () => void;
  onClose: () => void;
}

export const CreateClass: React.FC<Props> = ({ schoolId, onSuccess, onClose }) => {
  const [form] = Form.useForm();

  const handleCreate = async (value: any) => {
    const formData = {
      ...value,
      className: value.className?.trim(),
      classLevel: value.classLevel?.trim(),
      schoolId: schoolId,
    };

    const response: ResponseDataType<any> = await postRequest('/cms/class/create-class', formData, 'json');

    if (response?.code === 200) {
      toast.success('Thêm lớp học thành công!');
      form.resetFields();
      onSuccess();
      onClose();
    } else {
      toast.error(response?.msg || 'Thêm lớp học thất bại!');
    }
  };

  return (
    <Form form={form} onFinish={handleCreate} layout="vertical">
      <Form.Item
        name="classLevel"
        label="Khối"
        rules={[{ required: true, message: 'Vui lòng nhập khối' }]}
      >
        <Input placeholder="Nhập khối" />
      </Form.Item>
      <Form.Item
        name="className"
        label="Tên lớp"
        rules={[{ required: true, message: 'Vui lòng nhập tên lớp' }]}
      >
        <Input placeholder="Nhập tên lớp" />
      </Form.Item>
      <Form.Item name="classOrder" label="Thứ tự lớp">
        <Input placeholder="Nhập thứ tự lớp" />
      </Form.Item>
      <Form.Item name="description" label="Ghi chú">
        <Input placeholder="Nhập mô tả lớp học" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">Thêm lớp học</Button>
      </Form.Item>
    </Form>
  );
};
